import { fieldTraitProgressBarOptions, textTraitDateOptions } from '../../dataGroup/traitsApi';
import { getCollectionFields } from '../../pluginComponentApi';
export const CircularGaugeChartBlock = (bm, category, label, type) => {
  bm.add(type, {
    label: `<i class="webconnect-disc-fill"></i><div>${label}</div>`,
    category: category,
    content: `<div data-gjs-type="circular_gauge_chart">
                <img src="https://public-webconnect.s3.amazonaws.com/chart/circular-gauge.png" alt="circular gauge" />
            </div>`,
  });
};
export default (dc, label, type, config) => {
  const defaultType = dc.getType('default');
  const defaultModel = defaultType.model;
  const defaultView = defaultType.view;
  const { projectId, collections } = config;
  dc.addType(type, {
    model: defaultModel.extend(
      {
        defaults: {
          ...defaultModel.prototype.defaults,
          icon: '<i class="wb webconnect-disc-fill"></i>',
          projectId: projectId,
          name: 'Circular Gauge Chart',
          traits: [
            {
              type: 'select',
              label: 'Stroke LineCap',
              name: 'strokeLineCap',
              value: 'round',
              changeProp: 1,
              options: [
                { id: 'round', name: 'Round' },
                { id: 'square', name: 'Square' },
                { id: 'butt', name: 'Butt' },
              ],
            },
            {
              type: 'number',
              label: 'Height',
              name: 'chartHeight',
              changeProp: 1,
              value: 300,
              min: 100,
              step: 10,
              max: 1000,
            },
            {
              type: 'number',
              label: 'Hollow Size',
              name: 'hollowSize',
              changeProp: 1,
              value: 70,
              min: 10,
              step: 10,
              max: 90,
            },
            {
              type: 'number',
              label: 'Stroke Dash Array',
              name: 'strokeDashArray',
              changeProp: 1,
              value: 0,
              min: 0,
              step: 1,
              max: 10,
            },
            {
              type: 'number',
              label: 'Start Angle',
              name: 'startAngle',
              changeProp: 1,
              value: -135,
              min: -180,
              step: 10,
              max: 180,
            },
            {
              type: 'number',
              label: 'End Angle',
              name: 'endAngle',
              changeProp: 1,
              value: 135,
              min: -180,
              step: 10,
              max: 180,
            },
            { type: 'drapcode-circular-chart', label: false, name: 'test' },
          ],
          script: function () {
            const chartHeight = '{[ chartHeight ]}';
            const hollowSize = '{[ hollowSize ]}';
            const strokeLineCap = '{[ strokeLineCap ]}';
            const strokeDashArray = '{[ strokeDashArray ]}';
            const chartData = {
              chartHeight,
              hollowSize,
              strokeLineCap,
              strokeDashArray,
            };
            if (typeof renderCircularGaugeChart !== 'undefined') {
              renderCircularGaugeChart(this, chartData);
            }
          },
        },
        async init() {
          const collectionName = this.get('collectionName');
          let options = collections.map((item) => {
            return { value: item.collectionName, name: item.collectionTitle };
          });

          // this.addTrait([
          //   {
          //     type: 'select',
          //     label: 'Collection',
          //     name: 'collectionName',
          //     changeProp: 1,
          //     options: options,
          //   },
          //   {
          //     type: 'select',
          //     label: 'Filter',
          //     name: 'finderUuid',
          //     changeProp: 1,
          //   },
          // ]);
          if (collectionName) {
            const selectedCollection = collections.find(
              (collection) => collection.collectionName === collectionName,
            );
            const finderOptions = selectedCollection
              ? selectedCollection.finders.map((finder) => {
                  return { value: finder.uuid, name: finder.name };
                })
              : [];
            this.getTrait('finderUuid').set({ options: finderOptions });
          }
          this.on('change:collectionName', this.handleCollectionChange);
        },
        async handleCollectionChange() {
          const collectionName = this.get('collectionName');
          const collection = await getCollectionFields(collectionName, collections);
          this.setAttributes({
            selectedCollectionData: collection,
          });
          if (collection) {
            const finderOptions = [];
            collection.finders.forEach((finder) => {
              finderOptions.push({ value: finder.uuid, name: finder.name });
            });
            this.getTrait('finderUuid').set({ options: finderOptions });
            this.removeTrait('data-series');
            this.removeTrait('data-labels');
            const numberFieldTraitsOptions = fieldTraitProgressBarOptions(collection);
            const fieldTraitsOptions = await textTraitDateOptions(collection);
            this.addTrait({
              name: 'data-series',
              label: 'Series Data',
              options: numberFieldTraitsOptions,
              title: `series-data`,
              type: 'data-series-trait',
            });
            this.addTrait({
              name: 'data-labels',
              label: 'Label',
              options: fieldTraitsOptions,
              title: `Labels`,
              type: 'data-series-trait',
            });
          }
        },
      },
      {
        isComponent(el) {
          if (el.getAttribute && el.getAttribute('data-gjs-type') == type) {
            return {
              type: type,
            };
          }
        },
      },
    ),
    view: defaultView.extend({
      init({ model }) {
        this.listenTo(model, 'change:chartHeight', this.updateScript);
        this.listenTo(model, 'change:hollowSize', this.updateScript);
        this.listenTo(model, 'change:strokeLineCap', this.updateScript);
        this.listenTo(model, 'change:strokeDashArray', this.updateScript);
      },
    }),
  });
};
